import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isNullOrUndefined } from 'util';
//import { AuthenticationService } from '../_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  public data: string = "";
  constructor(
    private router: Router
    //  private authenticationService: AuthenticationService
  ) {
    this.data = sessionStorage.getItem('data');
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (!isNullOrUndefined(this.data)) {
      // authorised so return true
      return true;
    }
   // this.router.navigate(['/unauthorize']);

    // not logged in so redirect to login page
    this.router.navigate(['/unauthorize'], { queryParams: { returnUrl: state.url } });
    // return false;
  }
}
